module.exports = __webpack_public_path__ + "img/logo_4.4ce1785d.png";